import * as Yup from 'yup';
import { IDictionary } from '@constants/languages/types';

const schedulesValidationSchema = (dictionary: IDictionary) =>
  Yup.object({
    protocolName: Yup.string()
      .required(dictionary.validation.protocolName)
      .max(50, dictionary.validation.protocolNameMax),
    protocolNumber: Yup.string()
      .required(dictionary.validation.protocolNumber)
      .nullable()
      .max(50, dictionary.validation.protocolNumberMax),
    sponsorName: Yup.string()
      .required(dictionary.validation.sponsorName)
      .max(100, dictionary.validation.sponsorNameMax),
    physicianId: Yup.string()
      .required(dictionary.validation.physicianName)
      .max(100, dictionary.validation.invalidPhysicianName),
    plph: Yup.number()
      .required(dictionary.validation.plphValue)
      .nullable()
      .min(1, dictionary.validation.plphtMin)
      .max(100, dictionary.validation.plphtMax),
  });

export default schedulesValidationSchema;
